export default __webpack_public_path__ + "static/media/noAuthHome2.8be6b0da.svg";